import { render } from "./ElemEmpr_Existencia.vue?vue&type=template&id=2a5825e1"
import script from "./ElemEmpr_Existencia.vue?vue&type=script&lang=js"
export * from "./ElemEmpr_Existencia.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__